import React, { Component } from 'react'
import classnames from 'classnames'

/**
 * @description Step progress component
 *      USAGE
 *          <StepProgress
 *              *** PROPS ***
 *          />
 *
 *      PROPS - these props are required (if not be defined by conditions, nothing will be rendered)
 *          currentStep     - current step in progress. Must be number and is required
 *          countSteps      - count of all steps in progress. Must be number and is required
 *
 *
 *      PROPS - all props are optional
 *          emptyClassName  - used for additional classes for empty point (ex. can set color by background color,...)
 *          fillClassName   - used for additional classes for filled point (ex. can set color by background color,...)
 *          restProps       - all other props available as React says
 *
 */
export default class StepProgress extends Component {

    /**
     * Render function for step progress with points
     *
     * @return {null|*}
     */
    render() {
        const {
            currentStep,
            countSteps,
            emptyClassName,
            fillClassName,
            ...restProps
        } = this.props

        if (!Number.isInteger(currentStep) || !Number.isInteger(countSteps)) {
            return null
        }

        const points = [...Array(countSteps).keys()].map(stepIndex => {
            const isFilled = stepIndex < currentStep

            return (
                <div
                    key={stepIndex}
                    className={classnames({
                        'step-progress-point': true,
                        'step-progress-point--fill': isFilled,
                        [emptyClassName]: !!emptyClassName && !isFilled,
                        [fillClassName]: !!fillClassName && isFilled,
                    })}
                />
            )
        })

        return (
            <div
                className="step-progress"
                {...restProps}
            >
                {points}
            </div>
        )
    }
}
